// Convert Twitch clip URL to embed format and set parent domain.
// Handles both regular Twitch URLs (https://www.twitch.tv/{streamer}/clip/{clipId})
// and embed URLs (https://clips.twitch.tv/embed?clip={clipId}&parent={domain}).
export function getTwitchClipEmbedUrl(
  clipUrl: string,
  parentDomain: string
): string {
  if (!clipUrl || clipUrl === 'PLACEHOLDER' || !clipUrl.startsWith('http')) {
    return clipUrl;
  }

  try {
    const url = new URL(clipUrl);

    if (url.hostname === 'clips.twitch.tv' && url.pathname === '/embed') {
      url.searchParams.set('parent', parentDomain);
      return url.toString();
    }

    if (url.hostname === 'www.twitch.tv' || url.hostname === 'twitch.tv') {
      const pathParts = url.pathname.split('/');
      const clipIndex = pathParts.indexOf('clip');
      if (clipIndex !== -1 && clipIndex < pathParts.length - 1) {
        const clipId = pathParts[clipIndex + 1];
        return `https://clips.twitch.tv/embed?clip=${clipId}&parent=${parentDomain}`;
      }
    }

    return clipUrl;
  } catch {
    return clipUrl;
  }
}
